module.exports = __webpack_public_path__ + "Lato-Semibold.3b0cd7254b3b6ddb8a31.ttf";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/Lato/Lato-Semibold.ttf
// module id = ../../../../../src/assets/fonts/Lato/Lato-Semibold.ttf
// module chunks = styles